import React, { useState, useEffect } from 'react';

import { Button, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SortableContainer } from 'react-sortable-hoc';

import AddIcon from '@mui/icons-material/Add';

import Search from '../../../common/Search';
import CommonStyles from '../../../common/CommonStyles';

import BoundsListItem from './BoundsListItem';

const useStyles = makeStyles({
  boundsDraggableContainer: {
    overflowY: 'hidden',
    overflowX: 'hidden',
  },
  boundsDraggableContainerShadow: {
    boxShadow: 'inset 0px 2px 2px rgba(0, 0, 0, 0.03)',
  },
  boundsMainContainer: {
    display: 'flex',
    padding: '5px',
    background: '#fff',
    flexDirection: 'column',
  },
  newBoundsShadow: {
    boxShadow: '0px -2px 2px rgba(0, 0, 0, 0.03)',
  },
  newBoundsContainer: {
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  newBoundsTextarea: {
    width: '100%',
    border: 'none',
    resize: 'vertical',
    marginRight: '10px',
    boxSizing: 'border-box',
    '& .MuiInputBase-root': {
      padding: '0',
      color: '#4E4C4C',
      fontSize: '12px',
      lineHeight: '16.5px',
    },
    '& .MuiInputBase-input': {
      padding: '5px',
      background: '#EEECF8',
      boxSizing: 'border-box',
      '&:focus': {
        background: '#eeecf8',
      },
      '&::-webkit-scrollbar': {
        width: '3px',
        background: 'rgba(0,0,0, 0.2)',
      },
      '&::-webkit-scrollbar-track': {
        borderRadius: '5px',
        background: '#BCBCBC',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#878787',
        borderRadius: '10px',
      },
    },
  },
  newBoundsBtn: {
    padding: '0',
    minWidth: '0',
  },
  newBoundsBtnIcon: {
    color: '#DADADA',
    '&:hover': {
      color: '#C4C4C4',
      cursor: 'pointer',
    },
  },
  ...CommonStyles,
});

export default SortableContainer(
  ({
    nodes,
    items,
    boundsModal,
    addNewBounds,
    onBoundRemove,
    addNewNodeBound,
    onBoundsNewChange,
    onBoundFieldChange,
  }) => {
    const classes = useStyles();

    const [hasScroll, setHasScroll] = useState(false);
    const [scrollInTop, setScrollInTop] = useState(true);
    const [scrollInBottom, setScrollInBottom] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        const list = document.querySelector('.bounds-draggable-list');

        if (list) setHasScroll(list.scrollHeight > list.getBoundingClientRect().height);
      }, 100);
    }, []);

    useEffect(() => {
      const list = document.querySelector('.bounds-draggable-list');

      if (list) {
        const flag = list.scrollHeight > list.getBoundingClientRect().height;

        if (hasScroll !== flag) {
          setHasScroll(flag);
        }
      }
    });

    return (
      <div>
        <ul
          className={`bounds-draggable-list ${classes.boundsDraggableContainer} ${classes.styledScroll} ${
            classes.boundsMainContainer
          } ${hasScroll && !scrollInTop ? classes.boundsDraggableContainerShadow : ''}`}
          onScroll={() => {
            const list = document.querySelector('.bounds-draggable-list');

            if (list) {
              setScrollInTop(list.scrollTop === 0);
              setScrollInBottom(list.scrollTop === list.scrollHeight - list.offsetHeight);
            }
          }}
        >
          {items.map((item, index) => (
            <BoundsListItem
              item={item}
              key={index}
              index={index}
              nodes={nodes}
              classes={classes}
              itemIndex={index}
              lockToContainerEdges={true}
              onBoundRemove={onBoundRemove}
              isNode={boundsModal.type === 'node'}
              onBoundFieldChange={onBoundFieldChange}
            />
          ))}
        </ul>

        <div
          className={`${classes.boundsMainContainer} ${hasScroll && !scrollInBottom ? classes.newBoundsShadow : ''}`}
          style={{
            zIndex: 10000,
            position: 'relative',
          }}
        >
          <div className={classes.newBoundsContainer}>
            {boundsModal.type !== 'node' ? (
              <React.Fragment>
                <TextField
                  multiline
                  maxRows={100}
                  InputProps={{
                    disableunderline: 'true',
                  }}
                  value={boundsModal.boundsNew}
                  className={`${classes.newBoundsTextarea}`}
                  onChange={(e) => onBoundsNewChange(e.target.value)}
                />

                <Button className={classes.newBoundsBtn} disabled={!boundsModal.boundsNew.length}>
                  <AddIcon
                    className={classes.newBoundsBtnIcon}
                    style={{
                      color: `${boundsModal.boundsNew ? '#878787' : ''}`,
                    }}
                    onClick={addNewBounds}
                  />
                </Button>
              </React.Fragment>
            ) : (
              <Search
                containerStyles={{
                  width: '100%',
                  height: '24px',
                }}
                ancestorId={boundsModal.ancestor}
                onDropdownElementClick={({ node }) => {
                  addNewNodeBound(node);
                }}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
);
